import { Resume } from '@sr/types';
import Sections from '../common/Sections';
import { Box } from '../common/ui';
import BlockListSection from './BlockListSection';
import DetailSection from './DetailSection';
import Header from './Header';
import InlineListSection from './InlineListSection';
import theme from './keefer-theme';

const Keefer = ({ resume }: { resume: Resume }) => {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500&display=swap"
        rel="stylesheet"
      />
      <Header resume={resume} />
      <Box className="pdf-page-container">
        <Box className="pdf-page-column">
          <Sections
            resume={resume}
            filter="all"
            DetailSection={DetailSection}
            BlockListSection={BlockListSection}
            InlineListSection={InlineListSection}
          />
        </Box>
      </Box>
    </>
  );
};

Keefer.theme = theme;
export default Keefer;
